export var valuesLearningPathOriginEnum = ["Playlist", "PALMS"];
/*

*/ 
//# sourceMappingURL=LearningPathOriginEnum.js.map